import { render, staticRenderFns } from "./_form.vue?vue&type=template&id=89f06b9c&scoped=true&"
import script from "./_form.vue?vue&type=script&lang=js&"
export * from "./_form.vue?vue&type=script&lang=js&"
import style0 from "./_form.vue?vue&type=style&index=0&id=89f06b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f06b9c",
  null
  
)

export default component.exports